import {FieldConfig, FieldDataTypes, Uuid} from "@hidat/huijs-common";
import {HasTenantResource, ResourceConfig} from "@hidat/huijs-resource";
import {RblResourceInterface} from "../rbl-resource.interface";

export const TenantSettingConfig = new ResourceConfig('TenantSetting', 'tenant_settings', true, true)
  .addFields([
    new FieldConfig('category', FieldDataTypes.STRING, false),
    new FieldConfig('section', FieldDataTypes.STRING, false),
    new FieldConfig('klass', FieldDataTypes.STRING, false),
    new FieldConfig('settings', FieldDataTypes.UNKNOWN)
  ])

/**
 * Tenant Settings Interface
 * Object based settings/configurations for a tenant.
 */
export interface TenantSettingInterface extends RblResourceInterface<Uuid>, HasTenantResource {
  category: string | undefined;
  section: string | undefined;
  klass: string | undefined;
  settings: object | undefined;
  version: number | undefined;
}
